<template>
    <nav :class="menuClass" class="head-menu">
        <div class="main-menu__title--mobile">{{ lang('menu_title')}}</div>   
        <ul class="menu-ul">
            <li class="menu-item-wrap" v-for="menuItem in currentMenu" :key="menuItem.id" :class="{'hasChildren': menuItem.children }" >
                <div class="menu-item">
                    <a v-if="hasHttp(menuItem.target_link)" :href="menuItem.target_link" target="_blank">{{ menuItem.name }} </a> 
                    <router-link v-else :to="{ path: menuItem.target_link }">{{ menuItem.name }}</router-link> 
                    <span class="arrow menu-item__arrow" v-if="menuItem.children" @click.stop="toggleSubmenu()"></span>
                </div>         
                <div v-if="menuItem.children"  class="submenu-wrap" >
                    <div class="submenu__back-link" @click.stop="hideSubmenu()"><span>{{ menuItem.name }}</span></div>
                    <ul class="main-menu__submenu submenu" v-click-outside="toggleSubmenu">
                        <li v-for="menuSubItem in menuItem.children" :key="menuSubItem.id">   
                            <a v-if="hasHttp(menuSubItem.target_link)" :href="menuSubItem.target_link" target="_blank">{{ menuSubItem.name }} </a>                          
                            <router-link v-else :to="{ path: menuSubItem.target_link }">{{ menuSubItem.name }}</router-link>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </nav>
</template>


<script>
import $ from "jquery"

export default {
    data(){
        return {
            openedSubmenu: false            
        }
    },
    props: ['menu', 'menuClass'],
    computed: {        
        currentMenu(){            
            if ( this.menu == 1 ){                
                return this.$store.getters.getMenuHeaderMenu
            } else if ( this.menu == 2 ) {
                return this.$store.getters.getMenuMainMenu
            } else {
                return null
            }           
        }
    },
   watch:{
        $route: function(){                        
            this.setDefaultStateMenu()
        },
   },
    created(){          
        window.addEventListener("resize", this.setDefaultStateMenu);
    },
    methods:{               
       toggleSubmenu(){                     
        let item = event.target  
        // console.log('clickedmenuitem', item)       
        
        if ( $(item).hasClass('menu-item__arrow') && window.matchMedia('(max-width: 1199px)').matches ){
            let openedItem = $('.head-menu').find('.opened-children')
            let clickedItemClosest = $(item).closest('.opened-children')
            
            if ( $('.head-menu').find('.opened-children').length > 0 ){  
                //there was an opened item                      
                if ( openedItem[0] !=  clickedItemClosest[0]){                       
                    //the opened item not the clicked item
                    $('.head-menu').find('.opened-children').removeClass('opened-children')
                    $('.head-menu').find('.submenu-wrap').removeClass('opened')                  
                    // this.openedSubmenu = true;
                    $('.head-menu').find('.menu-ul').removeClass('openedSubmenu')
                    $(item).closest('.menu-ul').addClass('openedSubmenu')
                }               
                
            } else {         
                //open the clicked item   
                // this.openedSubmenu = true;            
                $(item).closest('.menu-ul').addClass('openedSubmenu')
            }
            $(item).closest('.menu-item-wrap').toggleClass('opened-children')
            $(item).closest('.menu-item').next('.submenu-wrap').toggleClass('opened')
        } else {
            if (window.matchMedia('(min-width: 992px)').matches) {
                $('.head-menu').find('.opened-children').removeClass('opened-children')
                $('.head-menu').find('.submenu-wrap').removeClass('opened')      
            }            
        }
        
      },
      hideSubmenu(){          
          let item = event.target
        //   this.openedSubmenu = false;
          $(item).closest('.menu-ul').removeClass('openedSubmenu')
          $(item).closest('.menu-item-wrap').removeClass('opened-children')
          $(item).closest('.submenu-wrap').removeClass('opened').addClass('closed')
      },
      setDefaultStateMenu(){
          //set the default state the all nav
          $('.head-menu').find('.menu-item-wrap').removeClass('opened-children');
          $('.head-menu').find('.submenu-wrap').removeClass('opened')
        //   this.openedSubmenu = false;
        $('.head-menu').find('.menu-ul').removeClass('openedSubmenu')
      }   
    },
    destroyed() {
        window.removeEventListener("resize", this.setDefaultStateMenu);
    },
}
</script>